import { type DateFormat, type TimeFormat } from '@ledium/types';

export function formatDate(value: number | string, format: DateFormat): string {
    let year: number;
    let month: number;
    let day: number;

    if (typeof value === 'number') {
        const d = new Date(value);
        year = d.getFullYear();
        month = d.getMonth() + 1;
        day = d.getDate();
    } else {
        const parts = value.split('-');
        year = parseInt(parts[0], 10);
        month = parseInt(parts[1], 10);
        day = parseInt(parts[2], 10);
    }

    const y = String(year).padStart(4, '0');
    const m = String(month).padStart(2, '0');
    const d = String(day).padStart(2, '0');

    switch (format) {
        case 'MM/DD/YYYY':
            return `${m}/${d}/${y}`;
        case 'DD/MM/YYYY':
            return `${d}/${m}/${y}`;
        default:
            return `${y}-${m}-${d}`;
    }
}

export function formatTime(value: string, format: TimeFormat): string {
    if (format === '24') {
        return value;
    }

    const parts = value.split(':');
    const hours = parseInt(parts[0], 10);
    const minutes = parts[1];
    const seconds = parts[2];
    const period = hours >= 12 ? 'PM' : 'AM';
    const hour12 = hours % 12 || 12;

    return `${hour12}:${minutes}:${seconds} ${period}`;
}
